///<reference path="../pages/home/home.ts"/>
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HTTP } from '@ionic-native/http'

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { Question1 } from '../pages/question1/question1';
import { Question2 } from '../pages/question2/question2';
import { Question3 } from '../pages/question3/question3';
import { Question4 } from '../pages/question4/question4';
import {Results} from "../pages/results/results";
import {GuestData} from "../pages/guest-data/guest-data";




@NgModule({
  declarations: [
    MyApp,
    HomePage,
    Question1,
    Question2,
    Question3,
    Question4,
    Results,
    GuestData
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    Question1,
    Question2,
    Question3,
    Question4,
    Results,
    GuestData
  ],
  providers: [
    StatusBar,
    SplashScreen,
    HTTP,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts